import React from 'react';
import Loader from '../../../../components/Loader';
import EditContactForm from './EditContactForm';
import ListContactsForm from './ListContactsForm';

export const formType = {
  LIST: 'LIST',
  EDIT: 'EDIT',
  ADD: 'ADD',
};

const ContactFormContainer = ({
  form,
  setForm,
  contacts,
  actions,
  contactFeatureOn,
}) => {
  const formName = form.name;

  let hasContacts = contacts.data && contacts.data.length > 0;

  let hasCloseContact =
    hasContacts &&
    contacts.data.filter((contact) => contact.closestContact === true)
      .length === 1;

  const formContext = {
    setForm,
    formName,
    hasContacts,
    hasCloseContact,
    contactFeatureOn,
  };

  switch (formName) {
    case formType.LIST:
      if (contacts.isFetching) return <Loader />;
      return (
        <ListContactsForm
          actions={actions}
          formContext={formContext}
          contacts={contacts.data}
          error={contacts.error}
        />
      );
    case formType.EDIT:
      let contact = contacts.data.filter((r) => r.id === form.id)[0];
      return (
        <EditContactForm
          actions={actions}
          formContext={formContext}
          contact={contact}
          error={contacts.error}
          isFetching={contacts.isFetching}
        />
      );
    case formType.ADD:
      return (
        <EditContactForm
          actions={actions}
          formContext={formContext}
          contact={{}}
          error={contacts.error}
          isFetching={contacts.isFetching}
        />
      );
    default:
      return null;
  }
};

export default ContactFormContainer;
